import { css } from "@linaria/core";

/** Narrow form — account/settings pages */
export const formNarrow = css`
  max-width: 480px;
`;

/** Standard form — content creation/editing */
export const formWide = css`
  max-width: 600px;
`;

/** Shrink-to-content width */
export const fitContent = css`
  width: fit-content;
`;

/** Standard width for in-page alert banners */
export const banner = css`
  max-width: 720px;
`;

/** Prevent line break inside a value + unit pair */
export const noWrap = css`
  white-space: nowrap;
`;

/** Pointer cursor for clickable non-button elements */
export const clickable = css`
  cursor: pointer;
`;

/** Strike-through for deleted entities */
export const deletedName = css`
  //text-decoration: line-through;
  color: var(--ant-color-text-tertiary);
`;

export const title = css`
  margin: 0;
`;
